import {
  CalendarOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  HomeOutlined,
  MailOutlined,
  PhoneOutlined,
  ProjectOutlined,
  TagOutlined,
  TeamOutlined,
  UserOutlined
} from "@ant-design/icons"
import React from "react"

// Longest prefix first where two entries overlap — "source_comment" would
// otherwise be answered by "source".
const ICON_BY_PREFIX: [string, React.ReactNode][] = [
  ["customer.email", <MailOutlined key="mail" />],
  ["customer.phone", <PhoneOutlined key="phone" />],
  ["customer.", <UserOutlined key="user" />],
  ["preferred_contact_method", <PhoneOutlined key="contact" />],
  ["address", <EnvironmentOutlined key="address" />],
  ["city", <EnvironmentOutlined key="city" />],
  ["state", <EnvironmentOutlined key="state" />],
  ["zip_code", <EnvironmentOutlined key="zip" />],
  ["project_type", <ProjectOutlined key="project" />],
  ["property_ownership", <HomeOutlined key="ownership" />],
  ["source_comment", <TeamOutlined key="referred" />],
  ["source", <TagOutlined key="source" />],
  ["architect_name", <TeamOutlined key="architect" />],
  ["budget_range", <DollarOutlined key="budget" />],
  ["timeline", <ClockCircleOutlined key="timeline" />],
  ["start_date", <CalendarOutlined key="start" />],
  ["end_date", <CalendarOutlined key="end" />],
  ["lead_name", <ProjectOutlined key="name" />],
  ["comments", <FileTextOutlined key="description" />],
  ["scope", <FileTextOutlined key="scope" />],
  ["internal_notes", <FileTextOutlined key="notes" />],
  ["customer", <UserOutlined key="record" />]
]

export function fieldIcon(fieldKey: string): React.ReactNode {
  const match = ICON_BY_PREFIX.find(([prefix]) => fieldKey.startsWith(prefix))
  return match?.[1] ?? <FileTextOutlined />
}
